<template>
  <div class="banner">
    <div class="title">
      <div class="text">{{ $t(`${this.i18nPrefix}.label.banner`) }}</div>
      <div v-if="hasError" class="error">{{ $t(`${this.i18nPrefix}.message.requireCustomCarouselFile`) }}</div>
    </div>
    <CustomContentEditor
      carouselSupportVideo
      ref="bannerEditor"
      :allowEdit="false"
      :carouselVideoMaxSizeize="videoMaxSize"
      :contentList="bannerSettingList"
    />
  </div>
</template>

<script>
import CustomContentEditor from '@/components/job/editor/customContentEditor.vue'
import _ from 'lodash'

export default {
  components: {
    CustomContentEditor
  },
  props: {
    bannerSetting: {
      type: Object,
      required: true
    },
    videoMaxSize: {
      type: Number,
      default: 10
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.job.editor',
      bannerData: {},
      bannerSettingList: [],
      hasError: false
    }
  },
  computed: {

  },
  created () {
  },
  mounted () {
  },
  methods: {
    async validate () {
      this.hasError = false
      const promiseList = _.map({
        bannerSetting: this.$refs.bannerEditor
      }, async (contentRef) => {
        const data = await contentRef.submit()
        if (data) {
          this.bannerData = data
        } else {
          this.hasError = true
        }
      })

      await Promise.all(promiseList)
      return !this.hasError
    },
    async submit () {
      const valid = await this.validate()
      if (!valid) {
        this.$nextTick(() => {
          this.$el.querySelector('.is-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        })
        return null
      }
      return this.bannerData[0]
    }
  },
  watch: {
    bannerSetting: {
      handler () {
        this.bannerSettingList = [this.bannerSetting]
        if (!this.bannerSetting.items || this.bannerSetting.items.length === 0) {
          this.bannerSettingList = [{
            type: 'silder',
            title: null,
            items: []
          }]
        }
      },
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
.banner {
  margin-top: 20px;

  .title {
    display: flex;
    align-items: center;

    .text {
      font-size: 16px;
      margin-right: 10px;
    }

    .error {
      font-size: 12px;
      color: #F56C6C;
    }
  }
  .content-list {
    display: flex;
    margin: 15px 0;
    border: 1px solid #DCDFE6;
    flex-flow: row wrap;
    min-height: 200px;

    .content-item {
      &.carousel-item {
        display: flex;
        width: 170px;
        margin: 0 9px;
        padding: 10px;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        .image-uploader {
          width: 100%;
          height: 150px;
        }

        .carousel-image-desc {
          margin: 10px 0;

          ::v-deep .el-input__inner {
            border-top: 0;
            border-left: 0;
            border-right: 0;
          }
        }
      }
    }
  }
}
</style>
